import api from "../api/axios";
import { Partner } from "./partner.types";

export const fetchPartners = async (): Promise<Partner[]> => {
  try {
    const response = await api.get("/internal-data/partners");
    return response.data.partners;
  } catch (error: any) {
    console.error("Error fetching partners from API:", error);
    throw new Error(error.response?.data?.error || error.message || "Failed to fetch partners");
  }
};